import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'purchase-list',
  name: '采购订单',
  icon: '采',
  group: 'ERP 组件',
  description: '展示采购订单和审批状态。',
  defaultProps: {
    title: '待处理采购',
    limit: 5
}
}
